export default __webpack_public_path__ + "static/survey-results-dark-249e51a0e9949890d7df6a921ad887f6.png";